/*
 * Shared stock-limit error renderer for [data-cart-line-error] (snippets/
 * cart-line.liquid). Loaded sitewide (layout/theme.liquid, ahead of
 * cart-drawer.js) so the drawer - present on every page - can use it too;
 * assets/cart-page.js (cart page only) uses the same sitewide instance
 * rather than keeping its own copy (FIX-PLAN-2026-09-11 #6: "share the
 * helper rather than copy it").
 */
window.showCartStockError = function showCartStockError(errorEl, item) {
  if (!errorEl) return;
  const template = errorEl.dataset.template || '';
  errorEl.textContent = template
    .replaceAll('{count}', item.quantity)
    .replaceAll('{variant}', item.variant_title || item.product_title || '');
  errorEl.hidden = false;
};
